<div class="reduce-risk-container text-center">
	<h2 class="mb-5 reduce-risk-header">Professional Services</h2>
	<p class="mt-4 reduce-risk-content mb-5">
		The RegScale Customer Success team partners with System Integrators and
		our channel partners to offer a full suite of complementary services
		that ensure each RegScale deployment maximizes business value for our
		customers. We give you just enough help to get started on your journey
		while providing seamless hand-offs to operations teams that can then own
		and operate the platform
	</p>
	<div class="row">
		<div class="col-xl-4 col-lg-12 mb-5">
			<div
				class="reduce-risk-card"
				style="
					background: linear-gradient(
						90deg,
						#29abe2 0%,
						#0ec7be 100%
					);
				"
			>
				<img src="../../assets/img/installation.svg" alt="" />
				<h3 class="reduce-risk-card-header">Installation</h3>
				<p class="mt-4" style="font-size: medium">
					We gather customer requirements and advise on the best
					installation option for each customer use case. We provide
					hands-on deployment engineers that can work with customer IT
					organizations to deploy RegScale either on premises or in the
					cloud.
				</p>
			</div>
		</div>
		<div class="col-xl-4 col-lg-12 mb-5">
			<div
				class="reduce-risk-card"
				style="
					background: linear-gradient(
						90deg,
						#29abe2 0%,
						#0ec7be 100%
					);
				"
			>
				<img src="../../assets/img/compliance-concierge.svg" alt="" />
				<h3 class="reduce-risk-card-header">Compliance Concierge</h3>

				<p class="mt-4" style="font-size: medium">
					We ensure that your installation is configured and loaded
					based on best practices. Our services include software
					configuration, AI-based data loading, and DevSecOps
					integration scripts to customer compliance data.
				</p>
			</div>
		</div>
		<div class="col-xl-4 col-lg-12">
			<div
				class="reduce-risk-card"
				style="
					background: linear-gradient(
						90deg,
						#29abe2 0%,
						#0ec7be 100%
					);
				"
			>
				<img src="../../assets/img/training.svg" alt="" />
				<h3 class="reduce-risk-card-header">Training</h3>

				<p class="mt-4" style="font-size: medium">
					We offer a flexible set of training options from online
					documentation, to YouTube videos, to customized classroom
					training that is tailored to each unique customer's needs.
				</p>
			</div>
		</div>
	</div>
</div>
